module.exports = __webpack_public_path__ + "img/chess_japanchess01.a26ab015.png";